import { watch } from "vue";
import { useTitle } from "@vueuse/core";

/**
 * Composable for dynamic page titles
 * useDynamicTitle(() => segment.name && `${segment.name} | Segments`)
 */
export function useDynamicTitle(getter) {
  const title = useTitle();

  watch(
    getter,
    value => {
      if (value) title.value = `${value} - Recurly Engage`;
    },
    { immediate: true },
  );
}
